var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 419,
    height: 48,
    viewBox: "0 0 419 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    clipPath: "url(#clip0_32_434)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 20.2031C3.5 19.6508 3.94772 19.2031 4.5 19.2031C5.05228 19.2031 5.5 19.6508 5.5 20.2031V27.7969C5.5 28.3492 5.05228 28.7969 4.5 28.7969C3.94772 28.7969 3.5 28.3492 3.5 27.7969V20.2031Z",
    fill: "url(#paint0_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20.2031C13.5 19.6508 13.9477 19.2031 14.5 19.2031C15.0523 19.2031 15.5 19.6508 15.5 20.2031V27.7969C15.5 28.3492 15.0523 28.7969 14.5 28.7969C13.9477 28.7969 13.5 28.3492 13.5 27.7969V20.2031Z",
    fill: "url(#paint1_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 16.4063C23.5 15.854 23.9477 15.4062 24.5 15.4062C25.0523 15.4062 25.5 15.854 25.5 16.4062V31.5938C25.5 32.146 25.0523 32.5938 24.5 32.5938C23.9477 32.5938 23.5 32.146 23.5 31.5938V16.4063Z",
    fill: "url(#paint2_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5 1.76172C33.5 1.20943 33.9477 0.761719 34.5 0.761719C35.0523 0.761719 35.5 1.20943 35.5 1.76172V46.2383C35.5 46.7906 35.0523 47.2383 34.5 47.2383C33.9477 47.2383 33.5 46.7906 33.5 46.2383V1.76172Z",
    fill: "url(#paint3_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5 11.6992C43.5 11.1469 43.9477 10.6992 44.5 10.6992C45.0523 10.6992 45.5 11.1469 45.5 11.6992V36.3008C45.5 36.8531 45.0523 37.3008 44.5 37.3008C43.9477 37.3008 43.5 36.8531 43.5 36.3008V11.6992Z",
    fill: "url(#paint4_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5 4.625C53.5 4.07272 53.9477 3.625 54.5 3.625C55.0523 3.625 55.5 4.07272 55.5 4.625V43.375C55.5 43.9273 55.0523 44.375 54.5 44.375C53.9477 44.375 53.5 43.9273 53.5 43.375V4.625Z",
    fill: "url(#paint5_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.5 10.9648C63.5 10.4126 63.9477 9.96484 64.5 9.96484C65.0523 9.96484 65.5 10.4126 65.5 10.9648V37.0352C65.5 37.5874 65.0523 38.0352 64.5 38.0352C63.9477 38.0352 63.5 37.5874 63.5 37.0352V10.9648Z",
    fill: "url(#paint6_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5 5.76172C73.5 5.20943 73.9477 4.76172 74.5 4.76172C75.0523 4.76172 75.5 5.20943 75.5 5.76172V42.2383C75.5 42.7906 75.0523 43.2383 74.5 43.2383C73.9477 43.2383 73.5 42.7906 73.5 42.2383V5.76172Z",
    fill: "url(#paint7_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.5 16.9297C83.5 16.3774 83.9477 15.9297 84.5 15.9297C85.0523 15.9297 85.5 16.3774 85.5 16.9297V31.0703C85.5 31.6226 85.0523 32.0703 84.5 32.0703C83.9477 32.0703 83.5 31.6226 83.5 31.0703V16.9297Z",
    fill: "url(#paint8_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.5 12.2383C93.5 11.686 93.9477 11.2383 94.5 11.2383C95.0523 11.2383 95.5 11.686 95.5 12.2383V35.7617C95.5 36.314 95.0523 36.7617 94.5 36.7617C93.9477 36.7617 93.5 36.314 93.5 35.7617V12.2383Z",
    fill: "url(#paint9_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.5 3.73828C103.5 3.186 103.948 2.73828 104.5 2.73828C105.052 2.73828 105.5 3.186 105.5 3.73828V44.2617C105.5 44.814 105.052 45.2617 104.5 45.2617C103.948 45.2617 103.5 44.814 103.5 44.2617V3.73828Z",
    fill: "url(#paint10_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.5 17.6953C113.5 17.143 113.948 16.6953 114.5 16.6953C115.052 16.6953 115.5 17.143 115.5 17.6953V30.3047C115.5 30.857 115.052 31.3047 114.5 31.3047C113.948 31.3047 113.5 30.857 113.5 30.3047V17.6953Z",
    fill: "url(#paint11_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.5 9.91016C123.5 9.35787 123.948 8.91016 124.5 8.91016C125.052 8.91016 125.5 9.35787 125.5 9.91016V38.0898C125.5 38.6421 125.052 39.0898 124.5 39.0898C123.948 39.0898 123.5 38.6421 123.5 38.0898V9.91016Z",
    fill: "url(#paint12_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.5 5.32812C133.5 4.77584 133.948 4.32812 134.5 4.32812C135.052 4.32812 135.5 4.77584 135.5 5.32812V42.6719C135.5 43.2242 135.052 43.6719 134.5 43.6719C133.948 43.6719 133.5 43.2242 133.5 42.6719V5.32812Z",
    fill: "url(#paint13_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.5 8.70312C143.5 8.15084 143.948 7.70312 144.5 7.70312C145.052 7.70312 145.5 8.15084 145.5 8.70312V39.2969C145.5 39.8492 145.052 40.2969 144.5 40.2969C143.948 40.2969 143.5 39.8492 143.5 39.2969V8.70312Z",
    fill: "url(#paint14_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.5 16.125C153.5 15.5727 153.948 15.125 154.5 15.125C155.052 15.125 155.5 15.5727 155.5 16.125V31.875C155.5 32.4273 155.052 32.875 154.5 32.875C153.948 32.875 153.5 32.4273 153.5 31.875V16.125Z",
    fill: "url(#paint15_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.5 20.2031C163.5 19.6508 163.948 19.2031 164.5 19.2031C165.052 19.2031 165.5 19.6508 165.5 20.2031V27.7969C165.5 28.3492 165.052 28.7969 164.5 28.7969C163.948 28.7969 163.5 28.3492 163.5 27.7969V20.2031Z",
    fill: "url(#paint16_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.5 13.8828C173.5 13.3305 173.948 12.8828 174.5 12.8828C175.052 12.8828 175.5 13.3305 175.5 13.8828V34.1172C175.5 34.6695 175.052 35.1172 174.5 35.1172C173.948 35.1172 173.5 34.6695 173.5 34.1172V13.8828Z",
    fill: "url(#paint17_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.5 15.832C183.5 15.2797 183.948 14.832 184.5 14.832C185.052 14.832 185.5 15.2797 185.5 15.832V32.168C185.5 32.7203 185.052 33.168 184.5 33.168C183.948 33.168 183.5 32.7203 183.5 32.168V15.832Z",
    fill: "url(#paint18_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.5 20.2031C193.5 19.6508 193.948 19.2031 194.5 19.2031C195.052 19.2031 195.5 19.6508 195.5 20.2031V27.7969C195.5 28.3492 195.052 28.7969 194.5 28.7969C193.948 28.7969 193.5 28.3492 193.5 27.7969V20.2031Z",
    fill: "url(#paint19_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.5 15.0898C203.5 14.5376 203.948 14.0898 204.5 14.0898C205.052 14.0898 205.5 14.5376 205.5 15.0898V32.9102C205.5 33.4624 205.052 33.9102 204.5 33.9102C203.948 33.9102 203.5 33.4624 203.5 32.9102V15.0898Z",
    fill: "url(#paint20_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.5 7.07812C213.5 6.52584 213.948 6.07812 214.5 6.07812C215.052 6.07812 215.5 6.52584 215.5 7.07812V40.9219C215.5 41.4742 215.052 41.9219 214.5 41.9219C213.948 41.9219 213.5 41.4742 213.5 40.9219V7.07812Z",
    fill: "url(#paint21_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.5 12.9766C223.5 12.4243 223.948 11.9766 224.5 11.9766C225.052 11.9766 225.5 12.4243 225.5 12.9766V35.0234C225.5 35.5757 225.052 36.0234 224.5 36.0234C223.948 36.0234 223.5 35.5757 223.5 35.0234V12.9766Z",
    fill: "url(#paint22_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.5 20.2031C233.5 19.6508 233.948 19.2031 234.5 19.2031C235.052 19.2031 235.5 19.6508 235.5 20.2031V27.7969C235.5 28.3492 235.052 28.7969 234.5 28.7969C233.948 28.7969 233.5 28.3492 233.5 27.7969V20.2031Z",
    fill: "url(#paint23_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.5 10.332C243.5 9.77975 243.948 9.33203 244.5 9.33203C245.052 9.33203 245.5 9.77975 245.5 10.332V37.668C245.5 38.2203 245.052 38.668 244.5 38.668C243.948 38.668 243.5 38.2203 243.5 37.668V10.332Z",
    fill: "url(#paint24_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.5 13C253.5 12.4477 253.948 12 254.5 12C255.052 12 255.5 12.4477 255.5 13V35C255.5 35.5523 255.052 36 254.5 36C253.948 36 253.5 35.5523 253.5 35V13Z",
    fill: "url(#paint25_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.5 20.2031C263.5 19.6508 263.948 19.2031 264.5 19.2031C265.052 19.2031 265.5 19.6508 265.5 20.2031V27.7969C265.5 28.3492 265.052 28.7969 264.5 28.7969C263.948 28.7969 263.5 28.3492 263.5 27.7969V20.2031Z",
    fill: "url(#paint26_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.5 12.7031C273.5 12.1508 273.948 11.7031 274.5 11.7031C275.052 11.7031 275.5 12.1508 275.5 12.7031V35.2969C275.5 35.8492 275.052 36.2969 274.5 36.2969C273.948 36.2969 273.5 35.8492 273.5 35.2969V12.7031Z",
    fill: "url(#paint27_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.5 2.28125C283.5 1.72896 283.948 1.28125 284.5 1.28125C285.052 1.28125 285.5 1.72897 285.5 2.28125V45.7188C285.5 46.271 285.052 46.7188 284.5 46.7188C283.948 46.7188 283.5 46.271 283.5 45.7188V2.28125Z",
    fill: "url(#paint28_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.5 15.4063C293.5 14.854 293.948 14.4062 294.5 14.4062C295.052 14.4062 295.5 14.854 295.5 15.4062V32.5938C295.5 33.146 295.052 33.5938 294.5 33.5938C293.948 33.5938 293.5 33.146 293.5 32.5938V15.4063Z",
    fill: "url(#paint29_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.5 20.2031C303.5 19.6508 303.948 19.2031 304.5 19.2031C305.052 19.2031 305.5 19.6508 305.5 20.2031V27.7969C305.5 28.3492 305.052 28.7969 304.5 28.7969C303.948 28.7969 303.5 28.3492 303.5 27.7969V20.2031Z",
    fill: "url(#paint30_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.5 3.88672C313.5 3.33443 313.948 2.88672 314.5 2.88672C315.052 2.88672 315.5 3.33443 315.5 3.88672V44.1133C315.5 44.6656 315.052 45.1133 314.5 45.1133C313.948 45.1133 313.5 44.6656 313.5 44.1133V3.88672Z",
    fill: "url(#paint31_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.5 20.0547C323.5 19.5024 323.948 19.0547 324.5 19.0547C325.052 19.0547 325.5 19.5024 325.5 20.0547V27.9453C325.5 28.4976 325.052 28.9453 324.5 28.9453C323.948 28.9453 323.5 28.4976 323.5 27.9453V20.0547Z",
    fill: "url(#paint32_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.5 11.5547C333.5 11.0024 333.948 10.5547 334.5 10.5547C335.052 10.5547 335.5 11.0024 335.5 11.5547V36.4453C335.5 36.9976 335.052 37.4453 334.5 37.4453C333.948 37.4453 333.5 36.9976 333.5 36.4453V11.5547Z",
    fill: "url(#paint33_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.5 5.66406C343.5 5.11178 343.948 4.66406 344.5 4.66406C345.052 4.66406 345.5 5.11178 345.5 5.66406V42.3359C345.5 42.8882 345.052 43.3359 344.5 43.3359C343.948 43.3359 343.5 42.8882 343.5 42.3359V5.66406Z",
    fill: "url(#paint34_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.5 20.2031C353.5 19.6508 353.948 19.2031 354.5 19.2031C355.052 19.2031 355.5 19.6508 355.5 20.2031V27.7969C355.5 28.3492 355.052 28.7969 354.5 28.7969C353.948 28.7969 353.5 28.3492 353.5 27.7969V20.2031Z",
    fill: "url(#paint35_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.5 20.2031C363.5 19.6508 363.948 19.2031 364.5 19.2031C365.052 19.2031 365.5 19.6508 365.5 20.2031V27.7969C365.5 28.3492 365.052 28.7969 364.5 28.7969C363.948 28.7969 363.5 28.3492 363.5 27.7969V20.2031Z",
    fill: "url(#paint36_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.5 20.2031C373.5 19.6508 373.948 19.2031 374.5 19.2031C375.052 19.2031 375.5 19.6508 375.5 20.2031V27.7969C375.5 28.3492 375.052 28.7969 374.5 28.7969C373.948 28.7969 373.5 28.3492 373.5 27.7969V20.2031Z",
    fill: "url(#paint37_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.5 1.39062C383.5 0.838339 383.948 0.390625 384.5 0.390625C385.052 0.390625 385.5 0.83834 385.5 1.39062V46.6094C385.5 47.1617 385.052 47.6094 384.5 47.6094C383.948 47.6094 383.5 47.1617 383.5 46.6094V1.39062Z",
    fill: "url(#paint38_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.5 1.82422C393.5 1.27193 393.948 0.824219 394.5 0.824219C395.052 0.824219 395.5 1.27193 395.5 1.82422V46.1758C395.5 46.7281 395.052 47.1758 394.5 47.1758C393.948 47.1758 393.5 46.7281 393.5 46.1758V1.82422Z",
    fill: "url(#paint39_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.5 11.4219C403.5 10.8696 403.948 10.4219 404.5 10.4219C405.052 10.4219 405.5 10.8696 405.5 11.4219V36.5781C405.5 37.1304 405.052 37.5781 404.5 37.5781C403.948 37.5781 403.5 37.1304 403.5 36.5781V11.4219Z",
    fill: "url(#paint40_linear_32_434)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.5 7.48828C413.5 6.936 413.948 6.48828 414.5 6.48828C415.052 6.48828 415.5 6.936 415.5 7.48828V40.5117C415.5 41.064 415.052 41.5117 414.5 41.5117C413.948 41.5117 413.5 41.064 413.5 40.5117V7.48828Z",
    fill: "url(#paint41_linear_32_434)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32_434",
    x1: 4.5,
    y1: 19.2031,
    x2: 4.5,
    y2: 28.7969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32_434",
    x1: 14.5,
    y1: 19.2031,
    x2: 14.5,
    y2: 28.7969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32_434",
    x1: 24.5,
    y1: 15.4062,
    x2: 24.5,
    y2: 32.5938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32_434",
    x1: 34.5,
    y1: 0.761719,
    x2: 34.5,
    y2: 47.2383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_32_434",
    x1: 44.5,
    y1: 10.6992,
    x2: 44.5,
    y2: 37.3008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_32_434",
    x1: 54.5,
    y1: 3.625,
    x2: 54.5,
    y2: 44.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_32_434",
    x1: 64.5,
    y1: 9.96484,
    x2: 64.5,
    y2: 38.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_32_434",
    x1: 74.5,
    y1: 4.76172,
    x2: 74.5,
    y2: 43.2383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_32_434",
    x1: 84.5,
    y1: 15.9297,
    x2: 84.5,
    y2: 32.0703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_32_434",
    x1: 94.5,
    y1: 11.2383,
    x2: 94.5,
    y2: 36.7617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_32_434",
    x1: 104.5,
    y1: 2.73828,
    x2: 104.5,
    y2: 45.2617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_32_434",
    x1: 114.5,
    y1: 16.6953,
    x2: 114.5,
    y2: 31.3047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_32_434",
    x1: 124.5,
    y1: 8.91016,
    x2: 124.5,
    y2: 39.0898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_32_434",
    x1: 134.5,
    y1: 4.32812,
    x2: 134.5,
    y2: 43.6719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_32_434",
    x1: 144.5,
    y1: 7.70312,
    x2: 144.5,
    y2: 40.2969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_32_434",
    x1: 154.5,
    y1: 15.125,
    x2: 154.5,
    y2: 32.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_32_434",
    x1: 164.5,
    y1: 19.2031,
    x2: 164.5,
    y2: 28.7969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_32_434",
    x1: 174.5,
    y1: 12.8828,
    x2: 174.5,
    y2: 35.1172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_32_434",
    x1: 184.5,
    y1: 14.832,
    x2: 184.5,
    y2: 33.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_32_434",
    x1: 194.5,
    y1: 19.2031,
    x2: 194.5,
    y2: 28.7969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_32_434",
    x1: 204.5,
    y1: 14.0898,
    x2: 204.5,
    y2: 33.9102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_32_434",
    x1: 214.5,
    y1: 6.07812,
    x2: 214.5,
    y2: 41.9219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_32_434",
    x1: 224.5,
    y1: 11.9766,
    x2: 224.5,
    y2: 36.0234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_32_434",
    x1: 234.5,
    y1: 19.2031,
    x2: 234.5,
    y2: 28.7969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_32_434",
    x1: 244.5,
    y1: 9.33203,
    x2: 244.5,
    y2: 38.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_32_434",
    x1: 254.5,
    y1: 12,
    x2: 254.5,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_32_434",
    x1: 264.5,
    y1: 19.2031,
    x2: 264.5,
    y2: 28.7969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_32_434",
    x1: 274.5,
    y1: 11.7031,
    x2: 274.5,
    y2: 36.2969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_32_434",
    x1: 284.5,
    y1: 1.28125,
    x2: 284.5,
    y2: 46.7188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_32_434",
    x1: 294.5,
    y1: 14.4062,
    x2: 294.5,
    y2: 33.5938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_32_434",
    x1: 304.5,
    y1: 19.2031,
    x2: 304.5,
    y2: 28.7969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_32_434",
    x1: 314.5,
    y1: 2.88672,
    x2: 314.5,
    y2: 45.1133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_32_434",
    x1: 324.5,
    y1: 19.0547,
    x2: 324.5,
    y2: 28.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_32_434",
    x1: 334.5,
    y1: 10.5547,
    x2: 334.5,
    y2: 37.4453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_32_434",
    x1: 344.5,
    y1: 4.66406,
    x2: 344.5,
    y2: 43.3359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_32_434",
    x1: 354.5,
    y1: 19.2031,
    x2: 354.5,
    y2: 28.7969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_32_434",
    x1: 364.5,
    y1: 19.2031,
    x2: 364.5,
    y2: 28.7969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_32_434",
    x1: 374.5,
    y1: 19.2031,
    x2: 374.5,
    y2: 28.7969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_32_434",
    x1: 384.5,
    y1: 0.390625,
    x2: 384.5,
    y2: 47.6094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_32_434",
    x1: 394.5,
    y1: 0.824219,
    x2: 394.5,
    y2: 47.1758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_32_434",
    x1: 404.5,
    y1: 10.4219,
    x2: 404.5,
    y2: 37.5781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_32_434",
    x1: 414.5,
    y1: 6.48828,
    x2: 414.5,
    y2: 41.5117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A54389"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 419,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.8c8219c4eb2afc616384ea1e2abc09a3.svg";
export { ForwardRef as ReactComponent };